import { ChatProviderType } from "../../domain/chat/models/ChatProviderType";
import chatIcon from '../../assets/chat-icon.png';

export const buildAvatarSrc = (providerType: ChatProviderType, agentIconUrl?: string): string => {
    if (providerType === ChatProviderType.ProGPT) {
        return chatIcon;
    }

    if (!agentIconUrl || agentIconUrl.startsWith('data:')) {
        return chatIcon;
    }

    if (agentIconUrl.startsWith('https://') || agentIconUrl.startsWith('http://')) {
        return agentIconUrl;
    }

    const cdnBaseUrl = process.env.REACT_APP_CDN_IMAGE_URL;
    return cdnBaseUrl ? cdnBaseUrl + agentIconUrl : chatIcon;
};